function beforeAndAfterCarousel() {
  const customerThumbList = document.querySelectorAll('.bna-results__results-thumb--item');
  const intervalDuration = 30000;
  let activeImageElement = document.querySelector('.bna-results__comparison-slider.active--bna');
  let activeCustomerElement = document.querySelector('.bna-results__results-thumb--item.active--bna-thumb');
  let sliderInterval = null;

  function switchToNextThumbnail() {
    const nextThumbIndex = Array.from(customerThumbList).indexOf(activeCustomerElement) + 1;
    const nextCustomerElement = customerThumbList[nextThumbIndex % customerThumbList.length];
    switchToThumbnail(nextCustomerElement);
  }

  function switchToThumbnail(thumb) {
    const thumbIndex = Array.from(customerThumbList).indexOf(thumb);
    const imageElement = document.querySelector(`.bna-results__comparison-slider-${thumbIndex}`);

    if (imageElement) {
      activeImageElement.classList.remove('active--bna');
      activeCustomerElement.classList.remove('active--bna-thumb');

      activeImageElement = imageElement;
      activeCustomerElement = thumb;

      activeImageElement.classList.add('active--bna');
      activeCustomerElement.classList.add('active--bna-thumb');
    }
  }

  customerThumbList.forEach((thumb) => {
    thumb.addEventListener('click', (e) => {
      clearInterval(sliderInterval);
      switchToThumbnail(thumb);
      sliderInterval = setInterval(switchToNextThumbnail, intervalDuration);
    });
  });

  sliderInterval = setInterval(switchToNextThumbnail, intervalDuration);
}

beforeAndAfterCarousel();
